export const QR_CODE_HEIGHT = 120;
export const QR_CODE_WIDTH = 100;
